import React, { useState, useEffect } from "react";
import {
  Button,
  TextField,
  FormHelperText,
  CircularProgress,
  InputLabel,
  NativeSelect,
  FormControl,
  Fade,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { Alert, AlertTitle } from "@material-ui/lab";
// data
import { CreateBankTransaction } from "./createBankTransactions-api";
//auth
import auth from "../../../auth/auth-helper";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: theme.spacing(1),
      width: 200,
    },
  },
}));

export default function Transactions() {
  var classes = useStyles();
  var [isLoading, setIsLoading] = useState(false);
  const [transType, setTransType] = useState([]);
  const [accountNo, setAccountNo] = useState([]);
  const [amount, setAmount] = useState([]);
  var [msg, setMsg] = useState(null);
  const [branchId, setBranchId] = useState(11);
  const [detail, setDetail] = useState([]);

  const clickSubmit = () => {
    setIsLoading(true);
    const abortController = new AbortController();
    const signal = abortController.signal;
    const credentials = auth.isAuthenticated();

    const transaction = {
      transaction_type: transType,
      account_no: accountNo,
      amount: amount,
      detail: detail,
      branch_id:branchId
    };

    CreateBankTransaction(signal, credentials, transaction).then((res) => {
      console.log(transaction);
      if (res.status === 200) {
        setMsg(res.response);
        console.log("token here ....................." + credentials);
        // console.log(res.status);
        console.log(res);
        //console.log(res.statusCode);
        //setTransactions(res.response[0]);
      } else {
        setMsg(res.response);
      }
      setIsLoading(false);
    });
  };

  return (
    <form className={classes.root} noValidate autoComplete="off">
      <div
        style={{
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <FormControl className={classes.formControl}>
          <InputLabel htmlFor="age-native-helper">Transaction</InputLabel>
          <NativeSelect
            value={transType}
            onChange={(e) => setTransType(e.target.value)}
            inputProps={{
              name: "age",
              id: "age-native-helper",
            }}
          >
            <option aria-label="None" value="" />
            <option value={"2"}>Deposit</option>
            <option value={"1"}>Withdraw</option>
          </NativeSelect>
          <FormHelperText>Please select an transaction type</FormHelperText>
        </FormControl>

        <br></br>
        <TextField
          label="Account No"
          value={accountNo}
          onChange={(e) => setAccountNo(e.target.value)}
          id="outlined-size-small"
          defaultValue="Small"
          variant="outlined"
          size="small"
        />
        <br></br>
        <TextField
          label="Amount"
          value={amount}
          onChange={(e) => setAmount(e.target.value)}
          id="outlined-size-small"
          defaultValue="Small"
          variant="outlined"
          size="small"
        />

        <br></br>
        <TextField
          label="Detail"
          value={detail}
          onChange={(e) => setDetail(e.target.value)}
          id="outlined-size-small"
          defaultValue="Small"
          variant="outlined"
          size="small"
        />
        <br></br>
        <div className={classes.creatingButtonContainer}>
          {isLoading ? (
            <CircularProgress size={26} />
          ) : (
            <Button
              disabled={
                transType.length === 0 ||
                accountNo.length === 0 ||
                amount.length === 0 ||
                detail.length === 0
              }
              variant="contained"
              color="primary"
              onClick={clickSubmit}
            >
              Continue
            </Button>
          )}
        </div>
        <Fade in={msg}>
          <Alert severity="info">
            <AlertTitle>Status</AlertTitle>
            {msg} <strong>check it out!</strong>
          </Alert>
        </Fade>
      </div>
    </form>
  );
}
